exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#editProjectedReceiverModal .v--modal-box.v--modal{min-height:250px!important;min-width:400px!important;max-width:450px!important;max-height:300px!important}#editProjectedReceiverModal .modal__content{overflow-y:hidden!important}#editProjectedReceiverModal .v-btn{height:95%;width:100%}#editProjectedReceiverModal .v-btn__content{white-space:normal}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-42059b60","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/viewer/modelWat/modals/EditProjectedReceiver.vue
// module id = 1828
// module chunks = 0